define('home/views/NotificationCardFollowView',[
    'underscore',
    'backbone',

    'home/views/common/ActivityCardView',
    'home/mixins/withReason',
    'home/mixins/asNotificationCard',
    'home/mixins/asCollapsibleCard',
    'home/mixins/withSubviews',

    'home/models/Session',

    'home/views/FollowerCollectionView',

    'home/templates/notificationCardFollow',
], function (
    _,
    Backbone,

    ActivityCardView,
    withReason,
    asNotificationCard,
    asCollapsibleCard,
    withSubviews,

    Session,

    FollowerCollectionView,

    notificationCardFollowTemplate
) {
    'use strict';

    var parent = ActivityCardView;

    var NotificationCardFollowView = parent.extend({
        className: function () {
            return 'card-notif-follow' +
                (this.shouldCollapse() ? ' card-collapsed' : '');
        },

        initialize: function () {
            this.session = Session.get();
            this.initializeShownActors();
        },

        initializeShownActors: function () {
            if (!this.shownActors)
                this.shownActors = _.pluck(this.model.activities, 'actor');
        },

        /**
         * Card collapses to hide more than 3 actors
         */
        shouldCollapse: function () {
            this.initializeShownActors();
            return this.shownActors.length > 3;
        },

        template: notificationCardFollowTemplate,
        templateHelpers: function () {
            return {
                hasOverflowActors: this.model.get('totalActors') > this.model.actors.length,
                sessionUsername: this.session.user.get('username'),
                shouldCollapse: this.shouldCollapse(),
            };
        },

        regions: {
            usersRegion: '[data-role=users]',
        },

        onRender: function () {
            this.activateRegion(this.usersRegion, this.createUsersView);
        },

        createUsersView: function () {
            return new FollowerCollectionView({
                user: this.session.user,
                el: this.usersRegion.el,
                itemViewOptions: function (_item, index) {
                    // Overwrite the FollowerCardView className which assumes the view is
                    // its own card
                    return {
                        className: 'followers__wrap' + (index > 2 ? ' collapsible' : ''),
                        showRemoveButton: true,
                    };
                },
                collection: new Backbone.Collection(this.shownActors),
            });
        },
    });


    var proto = NotificationCardFollowView.prototype;
    withReason.call(proto);
    asNotificationCard.call(proto);
    asCollapsibleCard.call(proto);
    withSubviews.call(proto);

    return NotificationCardFollowView;
});

